// This file is auto-generated by ./bin/rails stimulus:manifest:update
// Run that command whenever you add a new controller or create them with
// ./bin/rails generate stimulus controllerName

import { application } from "./application";

import AlertModalController from "./alert_modal_controller";
application.register("alert-modal", AlertModalController);

import AutoSubmitController from "./auto_submit_controller";
application.register("auto-submit", AutoSubmitController);

import CheckboxToggleController from "./checkbox_toggle_controller";
application.register("checkbox-toggle", CheckboxToggleController);

import DismissibleBannerController from "./dismissible_banner_controller";
application.register("dismissible-banner", DismissibleBannerController);

import FlashMessageController from "./flash_message_controller";
application.register("flash-message", FlashMessageController);

import PanelController from "./panel_controller";
application.register("panel", PanelController);

import ScratchGuiController from "./scratch_gui_controller";
application.register("scratch-gui", ScratchGuiController);

import ScratchGuiListenerController from "./scratch_gui_listener_controller";
application.register("scratch-gui-listener", ScratchGuiListenerController);

import SecondaryNavController from "./secondary_nav_controller";
application.register("secondary-nav", SecondaryNavController);

import StandardsSelectorController from "./standards_selector_controller";
application.register("standards-selector", StandardsSelectorController);

import StepperController from "./stepper_controller";
application.register("stepper", StepperController);

import ZippedResourcesController from "./zipped_resources_controller";
application.register("zipped-resources", ZippedResourcesController);
